import { useTranslation } from 'react-i18next';
import { usePageTitle } from '../layout/use-page-title.js';
import { UseCaseGrid } from '../components/use-case-grid.jsx';

/**
 * Index of all use cases, rendered from the USE_CASES registry.
 * @returns {JSX.Element}
 */
export function UseCasesIndexPage() {
	const { t } = useTranslation();
	usePageTitle('site.useCases.title', 'site.meta.useCases.description');

	return (
		<section className="use-cases-index">
			<header className="use-case-hero">
				<h1>{t('site.useCases.title')}</h1>
				<p className="use-case-lede">{t('site.home.useCases.lede')}</p>
			</header>
			<UseCaseGrid />
		</section>
	);
}
